import { buildCacheKey, type CacheKind } from './policy';
import { ANON_NS, getCacheNamespace } from './namespace';
import { readCache } from './httpCache';

/**
 * Reads the body of a previously cached GET without touching the network.
 *
 * The caller must pass the SAME url and params the axios call uses, because
 * the key is built the same way the response interceptor built it. Prefer the
 * typed helpers co-located with each api function over calling this directly.
 */
export async function peekCache<T>(
  kind: CacheKind,
  url: string,
  params?: Record<string, unknown>,
): Promise<T | null> {
  try {
    const ns = getCacheNamespace();
    if (ns === ANON_NS) return null;
    const entry = await readCache(buildCacheKey({ ns, kind, url, params }));
    return entry ? (entry.data as T) : null;
  } catch {
    return null;
  }
}
